import React from 'react'

const FooterSection = () => (
  <footer className='footer'>
    <p className='copyright'>Copyright ©︎ 2020 sharehome.biz</p>
  </footer>
)

export default FooterSection


// WEBPACK FOOTER //
// ./src/FooterSection.js